import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, OTHER_PROPS } from 'common/constants/component-props';
import { defaultProps } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const video = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.VIDEO> =>
	createModel({
		type: COMPONENT_TYPE.VIDEO,
		componentProps: {
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.size.height]: '11.25vw',
					},
				},
			},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.video.controls]: true,
						[OTHER_PROPS.video.videoSrc]: defaultProps.videoSrc,
						[OTHER_PROPS.video.videoPoster]: defaultProps.videoPoster,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.VIDEO>;
